import { SelectionDefinition } from 'app/types-shared';
import { SelectionFieldItem, SelectionValue } from './types-fields';
import { FieldItem } from 'app/area/reports/types';
import { codeItemToStoreValue } from 'app/infrastructure/data/codes';

export const mapToSelectionValue = (
  item: SelectionDefinition, 
  rollingAverage?: number
): SelectionFieldItem => {
  
  const field: FieldItem = codeItemToStoreValue(item.domain);

  const selectionValue: SelectionValue = {
    interval: item.interval,
    level: item.setLevelAccToCond
      ? { value: 0 }
      : !!item.levels
        ? { value: item.levels }
        : undefined,
    category: !!item.selectedCode || item.selectedCode === 0
      ? { value: item.selectedCode }
      : undefined,
    period: !!item.period && !!item.period.v
      ? codeItemToStoreValue(item.period)
      : undefined,
    rollingAverage,
    fillEmpty: !!item.fillEmpty,
    sortOrderType: !!item.sortOrderType && (!!item.sortOrderType.v || item.sortOrderType.v === 0)
      ? codeItemToStoreValue(item.sortOrderType)
      : undefined,
    type: item.type.v
  };

  return {
    selectionNo: item.id,
    field: field,
    value: selectionValue
  };
};
